import Vue from 'vue'

import spinnerLoader from '@/core/plugins/spinnerLoader.js'
Vue.prototype.$spinnerLoader = spinnerLoader

import customFunctions from '@/core/plugins/customFunctions.js'
Vue.prototype.$customFunctions = customFunctions

import generateToast from '@/core/plugins/generateToast.js'
Vue.prototype.$generateToast = generateToast

import urlify from '@/core/plugins/urlify.js'
Vue.prototype.$urlify = urlify

import capitalize from '@/core/plugins/capitalize.js'
Vue.prototype.$capitalize = capitalize
